"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const samedaydelivery = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-samedaydelivery` : '') + (description ? ` desc-samedaydelivery` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-samedaydelivery"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-samedaydelivery"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2008)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5618 0.303629C12.7406 0.232124 12.94 0.232124 13.1188 0.303629L23.7728 4.56463C24.0576 4.67851 24.2443 4.95429 24.2443 5.26097C24.2443 5.56765 24.0576 5.84344 23.7729 5.95735L13.1189 10.2193C12.94 10.2909 12.7406 10.2909 12.5617 10.2193L1.90773 5.95735C1.62299 5.84344 1.43629 5.56765 1.4363 5.26097C1.43631 4.95429 1.62304 4.67851 1.90779 4.56463L12.5618 0.303629ZM4.20578 5.26108L12.8403 8.71521L21.4748 5.26108L12.8403 1.80776L4.20578 5.26108Z",
    fill: "inherit"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32399 2.22085C7.93941 2.067 7.50293 2.25405 7.34908 2.63863C7.19523 3.02322 7.38228 3.4597 7.76686 3.61355L16.6806 7.17936L12.8403 8.71521L2.46484 4.56505C2.23378 4.47262 1.9719 4.50082 1.76582 4.64034C1.55973 4.77987 1.4363 5.0121 1.4363 5.26097L1.43628 8.1684C1.43628 8.58261 1.77207 8.9184 2.18628 8.9184C2.60049 8.9184 2.93628 8.58261 2.93628 8.1684V6.36922L12.09 10.0311V21.2549L8.98707 20.1835C8.59554 20.0483 8.16854 20.2561 8.03335 20.6476C7.89816 21.0391 8.10596 21.4661 8.49749 21.6013L12.5794 23.0108C12.7457 23.0724 12.9303 23.0737 13.0998 23.0111C13.1073 23.0083 13.1148 23.0054 13.1222 23.0024L23.7725 18.7429C24.0573 18.629 24.244 18.3532 24.244 18.0465L24.2443 5.26097C24.2443 5.0121 24.1206 4.77997 23.9145 4.64044C23.7084 4.50092 23.4465 4.47272 23.2155 4.56515L18.6998 6.37158L8.32399 2.22085ZM13.5903 10.0312V21.1997L22.744 17.5387V6.36931L13.5903 10.0312Z",
    fill: "inherit"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.304641 10.1569C0.459827 9.77286 0.89696 9.58734 1.281 9.74252L6.473 11.8405C6.85705 11.9957 7.04258 12.4328 6.88739 12.8169C6.7322 13.2009 6.29507 13.3865 5.91103 13.2313L0.719026 11.1333C0.334982 10.9781 0.149455 10.541 0.304641 10.1569Z",
    fill: "inherit"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.304641 17.3339C0.459827 16.9499 0.89696 16.7643 1.281 16.9195L6.473 19.0175C6.85705 19.1727 7.04258 19.6098 6.88739 19.9939C6.7322 20.3779 6.29507 20.5635 5.91103 20.4083L0.719027 18.3103C0.334982 18.1551 0.149455 17.718 0.304641 17.3339Z",
    fill: "inherit"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.38878 14.1789C1.54392 13.7948 1.98103 13.6093 2.3651 13.7644L6.2591 15.3374C6.64316 15.4925 6.82873 15.9297 6.67359 16.3137C6.51845 16.6978 6.08133 16.8834 5.69727 16.7282L1.80327 15.1552C1.41921 15.0001 1.23363 14.563 1.38878 14.1789Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2008"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = samedaydelivery;